import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { AddressFragmentDoc } from '../../../../lib/contexts/LocationDetailContext/LocationDetailContext.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InviteQrCodeDialogQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InviteQrCodeDialogQuery = { __typename?: 'Query', Locations: { __typename?: 'Locations', objects: Array<{ __typename?: 'Location', id: number, name: string, signupCode?: { __typename?: 'SignupCode', id: number, signupLink: string, signupQrcodeLink: string } | null }> } };

export type CreateLocationInQrCodeDialogMutationVariables = Types.Exact<{
  input: Types.CreateLocationInput;
}>;


export type CreateLocationInQrCodeDialogMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'LocationMutationResult', success: boolean, location?: { __typename?: 'Location', id: number, name: string, signupCode?: { __typename?: 'SignupCode', id: number, signupLink: string, signupQrcodeLink: string } | null, address?: { __typename?: 'Address', id: string, lineOne: string, lineTwo?: string | null, city: string, usState?: USState | null, country: string, postalCode: string, lat?: number | null, lng?: number | null } | null } | null } };


export const InviteQrCodeDialogDocument = gql`
    query InviteQRCodeDialog {
  Locations {
    objects {
      id
      name
      signupCode {
        id
        signupLink
        signupQrcodeLink
      }
    }
  }
}
    `;

/**
 * __useInviteQrCodeDialogQuery__
 *
 * To run a query within a React component, call `useInviteQrCodeDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteQrCodeDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQrCodeDialogQuery({
 *   variables: {
 *   },
 * });
 */
export function useInviteQrCodeDialogQuery(baseOptions?: Apollo.QueryHookOptions<InviteQrCodeDialogQuery, InviteQrCodeDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteQrCodeDialogQuery, InviteQrCodeDialogQueryVariables>(InviteQrCodeDialogDocument, options);
      }
export function useInviteQrCodeDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteQrCodeDialogQuery, InviteQrCodeDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteQrCodeDialogQuery, InviteQrCodeDialogQueryVariables>(InviteQrCodeDialogDocument, options);
        }
export type InviteQrCodeDialogQueryHookResult = ReturnType<typeof useInviteQrCodeDialogQuery>;
export type InviteQrCodeDialogLazyQueryHookResult = ReturnType<typeof useInviteQrCodeDialogLazyQuery>;
export type InviteQrCodeDialogQueryResult = Apollo.QueryResult<InviteQrCodeDialogQuery, InviteQrCodeDialogQueryVariables>;
export const CreateLocationInQrCodeDialogDocument = gql`
    mutation CreateLocationInQRCodeDialog($input: CreateLocationInput!) {
  createLocation(input: $input) {
    success
    location {
      id
      name
      signupCode {
        id
        signupLink
        signupQrcodeLink
      }
      address {
        ...Address
      }
    }
  }
}
    ${AddressFragmentDoc}`;
export type CreateLocationInQrCodeDialogMutationFn = Apollo.MutationFunction<CreateLocationInQrCodeDialogMutation, CreateLocationInQrCodeDialogMutationVariables>;

/**
 * __useCreateLocationInQrCodeDialogMutation__
 *
 * To run a mutation, you first call `useCreateLocationInQrCodeDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationInQrCodeDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationInQrCodeDialogMutation, { data, loading, error }] = useCreateLocationInQrCodeDialogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationInQrCodeDialogMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationInQrCodeDialogMutation, CreateLocationInQrCodeDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationInQrCodeDialogMutation, CreateLocationInQrCodeDialogMutationVariables>(CreateLocationInQrCodeDialogDocument, options);
      }
export type CreateLocationInQrCodeDialogMutationHookResult = ReturnType<typeof useCreateLocationInQrCodeDialogMutation>;
export type CreateLocationInQrCodeDialogMutationResult = Apollo.MutationResult<CreateLocationInQrCodeDialogMutation>;
export type CreateLocationInQrCodeDialogMutationOptions = Apollo.BaseMutationOptions<CreateLocationInQrCodeDialogMutation, CreateLocationInQrCodeDialogMutationVariables>;